<div class="modal-header" cdkDrag cdkDragRootElement=".modal-content" cdkDragHandle>
  <h5 class="modal-title">Select Email Addresses</h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()"></button>
</div>

<div class="modal-body">

  <!-- List header -->
  <div class="d-flex fw-semibold small border-bottom pb-2 mb-2">
    <span style="width: 150px;">Recipient Type</span>
    <span class="flex-grow-1">Email Address</span>
  </div>

  <!-- Address list -->
  <div style="max-height: 300px; overflow-y: auto;">
    <div *ngFor="let address of emailAddresses"
         class="d-flex align-items-center py-2 px-1 border-bottom small"
         [ngClass]="{'bg-primary text-white': address == selectedAddress}"
         style="cursor: pointer;"
         (click)="selectAddress(address)">
      <span style="width: 150px;">{{address.recipientType}}</span>
      <span class="flex-grow-1">{{address.emailAddress}}</span>
    </div>
  </div>

  <!-- To/CC inputs -->
  <div class="d-flex align-items-center gap-2 mt-3 mb-2">
    <button type="button" class="btn btn-outline-secondary btn-sm" style="width: 50px;"
      (click)="addToAddress(selectedAddress)">To</button>
    <input class="form-control form-control-sm" [(ngModel)]="selectedToAddresses">
  </div>

  <div class="d-flex align-items-center gap-2">
    <button type="button" class="btn btn-outline-secondary btn-sm" style="width: 50px;"
      (click)="addCCAddress(selectedAddress)">CC</button>
    <input class="form-control form-control-sm" [(ngModel)]="selectedCCAddresses">
  </div>

</div>

<div class="modal-footer">
  <button type="button" class="btn btn-success" (click)="selectAndClose()">OK</button>
</div>